import { Component, HostListener, OnInit } from '@angular/core';
import { MessagePageConfig, PasswordResetConfig, PwdResetCommonConfig, PwdResetFieldsConfig } from '../_model/passwordreset';
import { HomeService } from '../_services/home.service';
import { ActivatedRoute, Router } from '@angular/router';
import { NgForm } from '@angular/forms';
import { NgbModal, NgbModalConfig, NgbDateStruct, NgbDateAdapter, NgbDateParserFormatter } from '@ng-bootstrap/ng-bootstrap';
import { DatePipe } from '@angular/common';

export class CustomDateAdapter {
  fromModel(value: string): NgbDateStruct {
    if (!value)
      return null
    let parts = value.split('/');
    return { month: +parts[0], day: +parts[1], year: +parts[2] }
  }
  toModel(date: NgbDateStruct): string // from internal model -> your mode
  {
    return date ? ('0' + date.month).slice(-2) + "/" + ('0' + date.day).slice(-2) + "/" + date.year : null
  }
}
export class CustomDateParserFormatter {
  parse(value: string): NgbDateStruct {
    if (!value)
      return null
    let parts = value.split('/');
    return { month: +parts[0], day: +parts[1], year: +parts[2] } as NgbDateStruct
  }
  format(date: NgbDateStruct): string {
    return date ? ('0' + date.month).slice(-2) + "/" + ('0' + date.day).slice(-2) + "/" + date.year : null
  }
}

class LdapPasswordReset {
  userName: string;
  password: string;
  confirm_password: string;
  firstName: string;
  lastName: string;
  studentId: string;
  ssn: number;
  email: string;
  extraUserId: string;
  customizedUserId: string;
  dob: String;
}

@Component({
  selector: 'app-passwordreset',
  templateUrl: './passwordreset.component.html',
  styleUrls: ['./passwordreset.component.scss'],

  providers: [NgbModalConfig, NgbModal, DatePipe,
    { provide: NgbDateAdapter, useClass: CustomDateAdapter },
    { provide: NgbDateParserFormatter, useClass: CustomDateParserFormatter }
  ]
})
export class PasswordresetComponent implements OnInit {
  passwordreset: PasswordResetConfig;
  pwdResetCommonConfig: PwdResetCommonConfig;
  pwdResetFieldsConfig: Array<PwdResetFieldsConfig>;
  messagePageConfig: Array<MessagePageConfig>;
  i18n: any;
  passwordresetmock: any;
  formSubmitted: boolean = false;
  maxDate = {month: new Date().getMonth()+1, day: new Date().getDate(), year: new Date().getUTCFullYear()}
  minDate = {month: 1, day: 1, year: new Date().getUTCFullYear()-100}
  isOnCaptcha:boolean = false;
  isCaptcha:boolean = false;
  ngOnInit() {
  }

  constructor(private homeService: HomeService, public datepipe: DatePipe,
    private activatedRoute: ActivatedRoute, private router: Router) {
    this.getPasswordReset();
    this.i18n = homeService.session.get('i18n');
  }


  getPasswordReset() {
    this.homeService.getPasswordReset().subscribe(res => {
      if (res != null || res != undefined) {
        this.passwordreset=res.return_body;
        this.pwdResetCommonConfig = this.passwordreset.pwdResetCommonConfig;
        this.pwdResetFieldsConfig = this.passwordreset.pwdResetFieldsConfig;
        this.messagePageConfig = this.passwordreset.messagePageConfig;
        this.sortByOrder(this.passwordreset.pwdResetFieldsConfig);
        this.isCaptchaAvailable();
      }

    }, error => {
      console.log("No result found");
    });
  }

  sortByOrder(pwdResetFieldsConfig: any) {
      this.pwdResetFieldsConfig = pwdResetFieldsConfig.sort((a, b) => a['order'] > b['order'] ? 1 : a['order'] === b['order'] ? 0 : -1);
  }

  isCaptchaAvailable(){
    this.pwdResetFieldsConfig.forEach(data=>{
       if(data.fieldName === 'Captcha'){
        this.isCaptcha = true;
       }
    });
  }

  onVerify(token: string,f:NgForm){
    console.log(token)
    console.log(f.value);
    if(token!= undefined && token!=null){  
      console.log("CaptchaVerfied");
      var data = this.setFormData(f);
      this.ldapPwdReset(data);
     console.log(data);
    }
  }

  setFormData(f:NgForm){
    const data = new LdapPasswordReset();
    data.userName = f.value.User_Name;
    data.password = f.value.New_Password;
    data.confirm_password = f.value.Confirm_New_Password;
    data.firstName = f.value.First_Name;
    data.lastName = f.value.Last_Name;
    data.studentId = f.value.User_Id;
    data.ssn = f.value.Last_4_SSN;
    data.email = f.value.Email;
    data.extraUserId = f.value.Extra_User_ID;
    data.customizedUserId = f.value.Customized_User_Id;
    if(f.value.Date_of_Birth){
      data.dob = this.datepipe.transform(f.value.Date_of_Birth, 'yyyy-MM-dd');
    } else {
      data.dob = '';
    }
    return data;
  }

  ldapPwdReset(data){
       this.formSubmitted = true;
       this.homeService.sendMessage(true);
       this.homeService.getLdapPasswordReset(data).subscribe(res => {
       this.formSubmitted = false;
       this.ldapPwdReset = res.return_body;
       alert('Password Reset successful');
       this.router.navigate([this.router.url.split("/")[1],'home']);
       this.homeService.sendMessage(false);
     },
       error => {
         this.formSubmitted = false;
         this.homeService.sendMessage(false);
         alert(error.error.error_msg);
       });
   }
 
  submitNocaptcha(f:NgForm){
    console.log(f.value);
    var data = this.setFormData(f);
    this.ldapPwdReset(data);
  }

  captchaView(){
    this.isOnCaptcha = true;
  }

  @HostListener('document:click', ['$event'])
  documentClick(event: MouseEvent) {
      this.isOnCaptcha = false;
  }

  isDateNotRequired(f:NgForm) {
    console.log('data')
    this.pwdResetFieldsConfig.forEach(element=>{
        if(element.fieldName == 'Date_of_Birth' && !element.required && (f.value.Date_of_Birth == undefined || f.value.Date_of_Birth == null || f.value.Date_of_Birth == "")){
         f.form.controls['Date_of_Birth'].setErrors(null);
        }
    })
  }

}
